import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@/storybook/components/IconButton/IconButton';
import Popover from '@/storybook/components/Popover/Popover';
import { FilterLinesIcon, EditIcon, TrashIcon } from '@/storybook/icons';
import { ThreeDotsIcon } from '@/components/base/Icons/RocheIconPack';

import styles from './FilterActionsMenu.module.css';

interface FilterActionsMenuProps {
  onSeeDetails: () => void;
  onRename: () => void;
  onDelete: () => void;
}

const FilterActionsMenu: FC<FilterActionsMenuProps> = ({ onSeeDetails, onRename, onDelete }) => {
  const { t } = useTranslation();

  const menuContent = (
    <div className={styles.menuPanel}>
      <button type="button" className={styles.menuItem} onClick={onSeeDetails}>
        <FilterLinesIcon className={styles.menuIcon} />
        <span>{t('global.filters.manageSavedFilters.seeDetails')}</span>
      </button>
      <button type="button" className={styles.menuItem} onClick={onRename}>
        <EditIcon className={styles.menuIcon} />
        <span>{t('global.filters.manageSavedFilters.rename')}</span>
      </button>
      <button type="button" className={styles.menuItem} onClick={onDelete}>
        <TrashIcon className={styles.menuIcon} />
        <span>{t('global.filters.manageSavedFilters.delete')}</span>
      </button>
    </div>
  );

  return (
    <Popover
      size="S"
      noticePosition="bottom-left"
      raw
      withCloseButton={false}
      closeOnNoticeContentClick
      anchorContent={
        <IconButton
          appearance="text"
          icon={<ThreeDotsIcon height="2rem" width="2rem" />}
          aria-label={t('global.filters.manageSavedFilters.moreOptions')}
        />
      }
      noticeContent={menuContent}
    />
  );
};

export default FilterActionsMenu;
